// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wf-header[data-v-468e299b]{position:fixed;z-index:3;box-sizing:border-box;width:100%;border-radius:0}.wf-header-link[data-v-468e299b]{text-decoration:none;padding:0 .5rem}", ""]);
// Exports
module.exports = exports;
